export type DeepPartial<Thing> = Thing extends (...rest: unknown[]) => unknown
  ? Thing
  : Thing extends Array<infer InferredArrayMember>
    ? DeepPartialArray<InferredArrayMember>
    : Thing extends object
      ? DeepPartialObject<Thing>
      : Thing | undefined;

interface DeepPartialArray<Thing> extends Array<DeepPartial<Thing>> {}

type DeepPartialObject<Thing> = {
  [Key in keyof Thing]?: DeepPartial<Thing[Key]>;
};

export const plainBaseClasses = {
  backgroundColor: "bg-white dark:bg-neutral-750",
  backgroundColorSoft: "bg-gray-50 dark:bg-gray-900",
  textColor: "text-gray-800 dark:text-gray-300",
};
